//WMS - 入库管理api
import { ServerDistApi, ServerNoDistApi } from '@/group-cloud/network/ServerBizApi';

//配置下拉框值集
export const All_Sel_Option = 'all';
//库存状态
export const Mod_StockStatus_Types = {
    ZERO: 0,  //待确认
    ONE: 1,   //已确认
    TWO: 2,   //已入库
    THREE: 3,  //异常
    FOUR: 4,  //已取消
}

export const Mod_StockStatus_Options = [
    { id: All_Sel_Option, label: '全部' },
    { id: Mod_StockStatus_Types.ZERO, label: '待确认' },
    { id: Mod_StockStatus_Types.ONE, label: '已确认' },
    { id: Mod_StockStatus_Types.TWO, label: '已入库' },
    { id: Mod_StockStatus_Types.FOUR, label: '已取消'},
    { id: Mod_StockStatus_Types.THREE, label: '异常' },
];
export class WmsWarehousingApi {

    constructor() {
    }
    protected static groupUrl = '/wms/bill/input';

    //入库单列表查询
    public static async getBillList(data) {
        let uri = this.groupUrl + '/list';
        return await ServerDistApi.send(uri, data);
    }

     //入库单确认入库
     public static async sureInput(data) {
        let uri = this.groupUrl + '/confirm';
        return await ServerDistApi.get(uri, data);
    }

     //入库单取消入库
     public static async cancelInput(data) {
        let uri = this.groupUrl + '/cancel';
        return await ServerDistApi.get(uri, data);
    }

    //保存入库单
    public static async saveBill(data) {
        let uri = this.groupUrl + '/save';
        return await ServerDistApi.send(uri, data);
    }

    //获取单个入库单
    public static async oneBill(data) {
        let uri = this.groupUrl + '/get';
        return await ServerDistApi.get(uri, data);
    }

    //删除入库单
    public static async deleteBill(data) {
        let uri = this.groupUrl + '/delete';
        return await ServerDistApi.get(uri, data);
    }

    //取消入库单
    public static async cancelBill(data) {
        let uri = this.groupUrl + '/cancel';
        return await ServerDistApi.send(uri, data);
    }

    //仓位添加
    public static async saveLoc(data) {
        let uri = this.groupUrl + '/loc/save';
        return await ServerDistApi.send(uri, data);
    }

    //获取仓位
    public static async getLocList(data) {
        let uri = this.groupUrl + '/loc/list';
        return await ServerDistApi.send(uri, data);
    }

    //获取一个仓位信息
    public static async oneLocList(data) {
        let uri = this.groupUrl + '/loc/get';
        return await ServerDistApi.get(uri, data);
    }

    //获取工厂列表
    public static async getFactoryList(data) {
        let uri = '/erp/factory/list';
        return await ServerDistApi.get(uri, data);
    }

    //获取ERP列表
    public static async getErpList(data) {
        let uri = '/erp/bill/list';
        return await ServerDistApi.send(uri, data);
    }

    //获取ERP商品列表
    public static async getGoodsList(data) {
        let uri = '/erp/bill/detail';
        return await ServerDistApi.get(uri, data);
    }

    // 入库
    public static async wsMapping(data) {
        let url = '/wms/ws/mapping';
        return await ServerDistApi.get(url, data);
    }

    // 下载
    public static async downLoad(data) {
      let url = '/wms/bill/input/export';
      return await ServerDistApi.send(url, data);
  }

}


